import { TemplateGS } from "@ivanlog/gs";
import { StateApp } from "./StateApp";
import { App } from "../../App";

export class StatePaged<T extends TemplateGS> extends StateApp {

    protected readonly page: T;
    constructor(type: { new(): T }, title: string, inHistory: boolean) {
        super(title, inHistory);
        this.page = new type();
    }
    
    async afterStart(args?:any) {
        if (this.page)
            App.gui.showPage(this.page);
        await super.afterStart(args);
    }
}